const WITHHOLDING_AUTH_SHOWN_KEY = 'withholdingAuthShownOrderIds';
export const WITHHOLDING_AUTH_RETURN_QUERY = 'withholdingAuthReturn';
const H5_BASE_PATH = '/rental-h5';

function readShownOrderIds() {
  try {
    const raw = localStorage.getItem(WITHHOLDING_AUTH_SHOWN_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (e) {
    return [];
  }
}

function writeShownOrderIds(ids) {
  try {
    localStorage.setItem(WITHHOLDING_AUTH_SHOWN_KEY, JSON.stringify(ids));
  } catch (e) {
    // 写入失败仅影响重复提醒，不阻塞页面。
  }
}

export function hasWithholdingAuthShown(orderId) {
  const normalized = String(orderId == null ? '' : orderId).trim();
  if (!normalized) return false;
  return readShownOrderIds().includes(normalized);
}

export function markWithholdingAuthShown(orderId) {
  const normalized = String(orderId == null ? '' : orderId).trim();
  if (!normalized) return;
  const ids = readShownOrderIds();
  if (ids.includes(normalized)) return;
  ids.push(normalized);
  writeShownOrderIds(ids);
}

function normalizeRoutePath(route) {
  if (route && route.path) return route.path;
  if (typeof window === 'undefined' || !window.location) return '/';
  const pathname = window.location.pathname || '/';
  return pathname.indexOf(H5_BASE_PATH) === 0
    ? pathname.slice(H5_BASE_PATH.length) || '/'
    : pathname;
}

function setSearchParam(url, key, value) {
  if (value === undefined || value === null || value === '') return;
  if (Array.isArray(value)) {
    value.forEach(item => setSearchParam(url, key, item));
    return;
  }
  url.searchParams.set(key, value);
}

function readCurrentSearchQuery() {
  const query = {};
  if (typeof window === 'undefined' || !window.location) return query;
  const params = new URLSearchParams(window.location.search);
  params.forEach((value, key) => {
    query[key] = value;
  });
  return query;
}

export function buildWithholdingAuthRedirectUrl(route, extraQuery = {}) {
  if (typeof window === 'undefined' || !window.location) return '';
  const routePath = normalizeRoutePath(route);
  const normalizedPath = routePath.charAt(0) === '/' ? routePath : `/${routePath}`;
  const url = new URL(`${window.location.origin}${H5_BASE_PATH}${normalizedPath}`);
  const fallbackQuery = route && route.query
    ? {}
    : readCurrentSearchQuery();
  const query = {
    ...fallbackQuery,
    ...(route && route.query ? route.query : {}),
    ...extraQuery
  };
  Object.keys(query).forEach(key => setSearchParam(url, key, query[key]));
  url.searchParams.set(WITHHOLDING_AUTH_RETURN_QUERY, '1');
  return url.toString();
}

export function isWithholdingAuthReturn(route) {
  return route && route.query && route.query[WITHHOLDING_AUTH_RETURN_QUERY] === '1';
}

export function clearWithholdingAuthReturnQuery(router, route) {
  if (!router || !route || !route.query || route.query[WITHHOLDING_AUTH_RETURN_QUERY] !== '1') return;
  const query = { ...route.query };
  delete query[WITHHOLDING_AUTH_RETURN_QUERY];
  router.replace({ path: route.path, query });
}
